import { render, staticRenderFns } from "./therapy-form.vue?vue&type=template&id=129ca033&scoped=true&lang=pug&"
import script from "./therapy-form.vue?vue&type=script&lang=ts&"
export * from "./therapy-form.vue?vue&type=script&lang=ts&"
import style0 from "./therapy-form.vue?vue&type=style&index=0&id=129ca033&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129ca033",
  null
  
)

export default component.exports